<template>
  <v-card tile class="mx-1">
    <v-card-title>
      <p>{{ nivel.titulo }}</p> 
    </v-card-title>
    <v-divider></v-divider>

    <v-list v-if="isParent" class="mb-n1">
      <template v-if="parenteRealizacao">
        <v-list-item class="mt-n2" link>
          <v-list-item-content>
            <v-list-item-subtitle
              >{{
                parenteRealizacao.posicaoFormatada
              }}
              Realização</v-list-item-subtitle
            >
            <v-list-item-title>{{
              parenteRealizacao.descricao
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-if="parenteProduto">
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-subtitle
              >{{
                parenteProduto.posicaoFormatada
              }}
              Produto</v-list-item-subtitle
            >
            <v-list-item-title>
              {{ parenteProduto.descricao }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
    </v-list>
    
    <v-card-text class="pa-5 mb-n10 pt-3">
      <p class="mb-n1">{{ tituloNivel }}</p>
      <p class="text-h5">
        {{ logicaIntervencao.descricao }}
      </p>
    </v-card-text>
    <v-card-text class="pa-5">
      <p class="subtitle-1">
        <strong>Condições Prévias e Externas: </strong>
        {{
          logicaIntervencao.condicoesPreviasExternas
            ? logicaIntervencao.condicoesPreviasExternas
            : "Não se aplica."
        }}
      </p>
    </v-card-text>
    <v-card-actions class="pl-3 ml-n1 mt-n9">
      <LogicaIntervencaoEdit
        v-if="isPermissao"
        :titulo="tituloEdicao"
        :nivel="logicaIntervencao.nivel"
        :logicaIntervencao="{ ...logicaIntervencao }"
      ></LogicaIntervencaoEdit>
      <Confirm ref="confirm"></Confirm>
      <v-btn v-if="isPermissao" :disabled="!logicaIntervencao.edicao" @click="excluir" color="error text-center" small>Excluir</v-btn>
    </v-card-actions>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import LogicaIntervencaoEdit from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoEdit";
import Confirm from "@/components/Dialog/Confirm";
import { mapActions } from "vuex";

export default {
  components: {
    LogicaIntervencaoEdit,
    Confirm,
  },
  props: {
    logicaIntervencao: {
      require: true,
    },
    isParent: {
      default: false,
    },
  },
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },

    isPermissao() {
      //candEdit
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      var payload = {
        'permission': 'PERMISSION_LOGICA_INTERVERCAO_EDIT',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }
      
      return this.$store.getters["projeto/hasPermission"](payload);
    },

    nivel() {
      return this.$store.getters["enums/nivel"][this.logicaIntervencao.nivel];
    },
    tituloNivel() {
      return this.logicaIntervencao.posicaoFormatada + " " + this.nivel.titulo;
    },
    tituloDescricao() {
      return (
        this.logicaIntervencao.posicaoFormatada +
        " " +
        this.logicaIntervencao.descricao
      );
    },
    tituloExcluir() {
      return ("Excluir " + this.nivel.titulo);
    },
    descricaoExcluir() {
      return (
        this.logicaIntervencao.posicaoFormatada +
        " " +
        this.logicaIntervencao.descricao
      );
    },
    tituloEdicao() {
      return "Editar " + this.nivel.titulo;
    },
    route() {
      let route = this.nivel.route;
      route.params.projetoId = this.logicaIntervencao.projeto.id;
      route.params.logicaIntervencaoId = this.logicaIntervencao.id;

      return route;
    },
    parenteRealizacao() {
      if (this.logicaIntervencao.nivel === 'ATIVIDADE') {
        return this.logicaIntervencao.logicaIntervencao.logicaIntervencao;
      } else if (this.logicaIntervencao.nivel === 'RESULTADO_ESPERADO') {
        return this.logicaIntervencao.logicaIntervencao;
      }
      return null;
    },
    parenteProduto() {
      if (this.logicaIntervencao.nivel === "ATIVIDADE") {
        return this.logicaIntervencao.logicaIntervencao;
      }
      return null;
    },
  },
  data() {
    return {
      optionsExcluir: {
        color: "primary",
        width: 400,
        zIndex: 200,
      },
    };
  },
  methods: {
    ...mapActions("logicaIntervencao", ["excluirLogicaIntervencao"]),

    excluir() {
      this.$refs.confirm
        .open(
          this.tituloExcluir,
          this.descricaoExcluir,
          "Você tem certeza?",
          this.optionsExcluir
        )
        .then((confirm) => {
          if (confirm) {
            const payload = {
              projetoId: this.logicaIntervencao.projeto.id,
              logicaIntervencaoId: this.logicaIntervencao.id,
            };

            this.excluirLogicaIntervencao(payload)
            this.$router.push({ name: 'Matriz', params: { projetoId: this.$route.params.projetoId } })
          }
        });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>